import { ArrowBack, Chat } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AppDrawer from "../../Layout/AppDrawer";
import { useLocation, useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { useEffect, useRef, useState } from "react";
import { findDuration, splitDateTime } from "../../Utils/utils";
import { getData, putData } from "../../API/apiService";
import { useAuth } from "../../customHooks/AuthContext";
import CachedIcon from "@mui/icons-material/Cached";
import SessionFeedback from "./SessionFeedback";
import {
  sessionAutoRefreshTiming,
  sessionReportMaxAttemptCount,
} from "../../Utils/constant";
import React from "react";

import {
  TreatmentPlanPharmacologicalTable,
  TreatmentPlanNonPharmacologicalTable,
} from "./TreatmentPlanPharmacologicalTable";
import NonMentalSessionSummary from "./NonMentalSessionSummary";
import MentalSessionSummary from "./MentalSessionSumary";
import LoadingReport from "./LoadingReport";
import AssessmentRecommendation from "./AssessmentRecommendation";
import PatientFormatArray from "./TreatmentFormat";
import AssessmentRecommendationSubthreshold from "./AssessmentRecommendationSubthreshold";
import { commonBtnStyle } from "../../style";
import { LoadingButton } from "@mui/lab";

interface DataItem {
  [key: string]: string[];
}

type SummaryEntry = [string, Record<string, any>];



// interface SessionDignosisType {
//   disorder: string;
//   code: string;
//   severity: string;
// }

export const sessionReportTitle = {
  display: "block",
  fontWeight: "bold",
  marginLeft: "1pc",
  backgroundColor: "#fff6d1",
  width: "100%",
  padding: "0.5em",
};

export const dignosisReportSubtitle = {
  display: "block",
  fontWeight: "bold",
  marginLeft: "1pc",
  backgroundColor: "#fff6d1",
  width: "fit-content",
  borderRadius: "4px",
  padding: "0.3em",
};

export const sessionReportSubtitle = {
  display: "block",
  fontWeight: "bold",
  marginLeft: "1pc",
  backgroundColor: "#ffe478",
  width: "fit-content",
  borderRadius: "4px",
  padding: "0.3em",
};

export const sessionReportSummaryReportTitle = {
  display: "block",
  fontWeight: "bold",
  marginLeft: "1pc",
  backgroundColor: "#f1f1f1",
  width: "fit-content",
  padding: "0.5em",
};

const SessionReport = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { adminPractitionerId, role } = useAuth();
  const { patientDetails, sessionid } = location.state || {};
  const sessionData = localStorage.getItem("userData");
  const practionerDetails = sessionData ? JSON.parse(sessionData) : {};
  const [duration, setDuration] = useState<string>("");
  const sessionTranscriptintervalIdRef = useRef<number | null>(null);
  const sessionSummaryintervalIdRef = useRef<number | null>(null);
  const sessionTreatmentPlanintervalIdRef = useRef<number | null>(null);
  const [sessionDate, setSessionDate] = useState("-");
  const [sesssionTime, setSessionTime] = useState("-");

  // Session Transcript
  const [sessionTranscriptList, setSessionTranscriptList] = useState<any[]>([]);
  // ── EDIT MODE SETUP ───────────────────────────────────────────────────────────
  const [sessionTranscriptEditMode, setSessionTranscriptEditMode] = useState<boolean>(false);
  const [editedLines, setEditedLines] = useState<string[]>([]);

  // Session Summary Edit/Update
  const [sessionSummaryEditMode, setSessionSummaryEditMode] = useState(false);
  // const [sessionSummaryUpdate, setSessionSummaryUpdate] = useState(false);
  const [sessionSummaryAPIResponse, setSessionSummaryAPIResponse] = useState();


  // AssessmentRecommendation Edit/Update
  const [assessmentRecommendationEditMode, setAssessmentRecommendationEditMode] = useState(false);




  //TreatmentPlanPharmacologicalTable_editedStates

  const [TreatmenteditMode, setTreatmentEditMode] = useState(false);
  const [TreatmentTextInputs, setTreatmentTextInputs] = useState<
    Record<string, string>
  >({});




  // When entering edit mode, seed editedLines from the current transcript
  useEffect(() => {
    if (sessionTranscriptEditMode) {
      setEditedLines(sessionTranscriptList.map((item) => item.text));
    }
  }, [sessionTranscriptEditMode, sessionTranscriptList]);

  // const handleEditToggle = () => setSessionTranscriptEditMode((on) => !on);

  const handleLineChange = (idx: number, val: string) => {
    const copy = [...editedLines];
    copy[idx] = val;
    setEditedLines(copy);
  };

  //TreatmentPlanPharmacologicalTable
  const handleTreatmentTextInputChange = (fieldKey: string, value: string) => {
    setTreatmentTextInputs((prev) => ({
      ...prev,
      [fieldKey]: value,
    }));

    // Also update the treatmentReportObject
    handleTreatmentInputChange(fieldKey, value, "treatment");
  };


  const [mentalSessionSummaryReportObject, setMentalSessionSummaryReportObject] = useState<any>({});
  const [diagnosisDisplayObject, setDiagnosisDisplayObject] = useState<any>({});
  const [dignosisReportObject, setdignosisReportObject] = useState<any>({});
  const [treatmentReportObject, setTreatmentReportObject] = useState<any>({});
  const [isReportButtonDisabledDueToLoading,setIsReportButtonDisabledDueToLoading] = useState(false);

  const handleReportUpdate = async (reportType: string) => {
    setIsReportButtonDisabledDueToLoading(true);
    try {
      if (reportType === 'transcript') {
        const updatedList = sessionTranscriptList.map((item, i) => ({
          speaker: item.speaker,
          text: editedLines[i]!, // your edited text
        }));
        setSessionTranscriptList(updatedList);
        const payload = JSON.stringify(updatedList, null, 2);
        await putData(
          `/update-report/${adminPractitionerId && role === "admin" ? adminPractitionerId : practionerDetails.practionerInfo.id}/${patientDetails.id}/${sessionid}/${reportType}`, payload
        );
        handleSessionTranscriptCloseMode();
      } else if (reportType === "summary" || reportType === 'dignosis') {
        const payload = Object.fromEntries(sessionSummaryAPIResponse ?? []);
        for (const [key, newValue] of Object.entries(mentalSessionSummaryReportObject)) {
          if (key in payload && typeof payload[key] === 'object' && !Array.isArray(payload[key])) {
            payload[key] = {
              ...(payload[key] as Record<string, any>),
              ...(newValue as Record<string, any>)
            };
          } else {
            payload[key] = newValue;
          }
        }
        await putData(
          `/update-report/${adminPractitionerId && role === "admin" ? adminPractitionerId : practionerDetails.practionerInfo.id}/${patientDetails.id}/${sessionid}/all-summaries`, payload
        );

        console.log("🔥 SENDING DIAGNOSIS UPDATE:", JSON.stringify(dignosisReportObject, null, 2));
        if (reportType === "dignosis") {
          const response = await putData(
            `/update-report/${adminPractitionerId && role === "admin" ? adminPractitionerId : practionerDetails.practionerInfo.id}/${patientDetails.id}/${sessionid}/diagnosis`, dignosisReportObject
          );
          console.log("🔥 API RESPONSE:", response);
        }

        if (reportType === "summary") {
          handleSessionSummaryCloseMode();
        } else if (reportType === "dignosis") {
          handleAssessmentRecommendationCloseMode();
        }
      } else if (reportType === "treatment") {
        console.log("🔥 TREATMENT UPDATE TRIGGERED!");
        console.log("🔥 SENDING TREATMENT UPDATE:", JSON.stringify(treatmentReportObject, null, 2));

        const response = await putData(
          `/update-report/${adminPractitionerId && role === "admin" ? adminPractitionerId : practionerDetails.practionerInfo.id}/${patientDetails.id}/${sessionid}/treatment`, treatmentReportObject
        );

        console.log("🔥 TREATMENT API RESPONSE:", response);
        handleTreatmentCloseMode();
      }
      setIsReportButtonDisabledDueToLoading(false);
    } catch (error) {
      console.error("Error updating the report:", error);
    }
  }

  const handleDiagnosisInputChange = (keyWithIndex: string, value: string, section: string) => {
    console.log("🔥 DIAGNOSIS INPUT CHANGE CALLED:", keyWithIndex, value, section);

    // Extract diagnosis type from section (e.g., 'summary_sud' -> 'sud')
    const diagnosisType = section.replace('summary_', '');

    // No field mapping needed - using actual diagnosis field names directly

    setdignosisReportObject((prevDiagnosis: any) => {
      if (Array.isArray(prevDiagnosis) && prevDiagnosis.length > 1) {
        const updatedDiagnosis = [...prevDiagnosis];
        const clinicalFindings = Array.isArray(updatedDiagnosis[1]) ? [...updatedDiagnosis[1]] : [updatedDiagnosis[1]];

        // The clinical findings is an array with one object containing all diagnosis types
        if (clinicalFindings.length > 0 && clinicalFindings[0][diagnosisType]) {
          const match = keyWithIndex.match(/(.*)\[(\d+)\]/);
          if (match) {
            const key = match[1];
            const index = parseInt(match[2]);

            // Use the field name directly
            const actualFieldName = key;

            // Update array field
            const updatedArray = [...(clinicalFindings[0][diagnosisType][actualFieldName] || [])];
            updatedArray[index] = value;

            clinicalFindings[0] = {
              ...clinicalFindings[0],
              [diagnosisType]: {
                ...clinicalFindings[0][diagnosisType],
                [actualFieldName]: updatedArray
              }
            };
          } else {
            // Update single field
            const actualFieldName = keyWithIndex;
            clinicalFindings[0] = {
              ...clinicalFindings[0],
              [diagnosisType]: {
                ...clinicalFindings[0][diagnosisType],
                [actualFieldName]: [value]
              }
            };
          }

          updatedDiagnosis[1] = clinicalFindings;
          console.log("🔥 UPDATED DIAGNOSIS OBJECT:", updatedDiagnosis);

          // Also update the display object to reflect changes immediately
          setDiagnosisDisplayObject((prevDisplay: any) => {
            const updatedDisplay = { ...prevDisplay };
            if (updatedDisplay[section]) {
              const match = keyWithIndex.match(/(.*)\[(\d+)\]/);
              if (match) {
                const key = match[1];
                const index = parseInt(match[2]);
                const updatedArray = [...(updatedDisplay[section][key] || [])];
                updatedArray[index] = value;
                updatedDisplay[section] = {
                  ...updatedDisplay[section],
                  [key]: updatedArray
                };
              } else {
                updatedDisplay[section] = {
                  ...updatedDisplay[section],
                  [keyWithIndex]: [value]
                };
              }
            }
            return updatedDisplay;
          });

          return updatedDiagnosis;
        }
      }
      return prevDiagnosis;
    });
  };

  const handleTreatmentInputChange = (keyWithIndex: string, value: string, section: string) => {
    console.log("🔥 TREATMENT INPUT CHANGE CALLED:", keyWithIndex, value, section);

    setTreatmentReportObject((prevTreatment: any) => {
      if (Array.isArray(prevTreatment) && prevTreatment.length > 0) {
        const updatedTreatment = [...prevTreatment];

        // Treatment data structure is different - it's an array of objects with codes as keys
        for (let i = 0; i < updatedTreatment.length; i++) {
          const treatmentItem = updatedTreatment[i];
          const codeKey = Object.keys(treatmentItem)[0]; // Get the code key (like "F10.20")

          if (treatmentItem[codeKey]) {
            const match = keyWithIndex.match(/(.*)\[(\d+)\]/);
            if (match) {
              const key = match[1];
              const index = parseInt(match[2]);

              // Update array field
              const updatedArray = [...(treatmentItem[codeKey][key] || [])];
              updatedArray[index] = value;

              updatedTreatment[i] = {
                ...treatmentItem,
                [codeKey]: {
                  ...treatmentItem[codeKey],
                  [key]: updatedArray
                }
              };
            } else {
              // Update single field
              updatedTreatment[i] = {
                ...treatmentItem,
                [codeKey]: {
                  ...treatmentItem[codeKey],
                  [keyWithIndex]: [value]
                }
              };
            }
            break; // Found and updated, exit loop
          }
        }

        console.log("🔥 UPDATED TREATMENT OBJECT:", updatedTreatment);
        return updatedTreatment;
      }
      return prevTreatment;
    });
  };

  const handleSetDignosisReportObject = (value: any) => {
    console.log("value", value);
    // Merge the updated clinical findings back into the original diagnosis structure
    setdignosisReportObject((prevDiagnosis: any) => {
      if (Array.isArray(prevDiagnosis) && prevDiagnosis.length > 2) {
        // Update the clinical findings part (index 1) with the new value
        const updatedDiagnosis = [...prevDiagnosis];
        updatedDiagnosis[1] = value;
        return updatedDiagnosis;
      }
      return value;
    });
  }
  const [sessionTranscriptLoading] = useState<boolean>(false);
  const [sessionTranscriptisExpanded, setSessionTranscriptisExpanded] =
    useState(false);

  // Session Summary
  const [sessionSummaryList, setSessionSummaryList] = useState<any[]>([]);
  const [sessionSummaryLoading] = useState<boolean>(false);
  const [sessionSummaryIsExpanded, setsessionSummaryIsExpanded] =
    useState(false);
  const [sessionSummaryListData, setSessionSummaryListData] = useState<
    SummaryEntry[]
  >([]);
  const [sessionSummaryType, setSessionSummaryType] = useState("");

  // Diagnosis
  const [diagnosisList, setDiagnosisList] = useState<any[]>([]);
  const [diagnosisLoading, setDignosisLoading] = useState<boolean>(false);
  const [diagnosisIsExpanded, setDiagnosisIsExpanded] = useState(false);
  const [principalClinicalFindingsList, setPrincipalClinicalFindingsList] =
    useState<any[]>([]);
  // const [availableDignosisTypeList, setAvailableDignosisTypeList] = useState<
  //   String[]
  // >([]);
  // const [isAllDignosisEmpty, setIsAllDignosisEmpty] = useState(false);
  const [dignosisPrincipalList, setDignosisPrincipalList] = useState<String[]>(
    []
  );
  const [dignosisSubthresholdList, setDignosisSubthresholdList] = useState<
    String[]
  >([]);

  // Treatment plan
  const [treatmentPlanList, setTreatmentPlanList] = useState<any[]>([]);
  const [treatmentLoading] = useState<boolean>(false);
  const [treatmentIsExpanded, setTreatmentPlanIsExpanded] = useState(false);
  const [pharmacologicalMedicationList, setpharmacologicalMedicationList] =
    useState<any[]>([]);
  const [
    nonPharmacologicalMedicationList,
    setNonPharmacologicalMedicationList,
  ] = useState<any[]>([]);

  const [currentExpandedReport, setCurrentExpandedReport] = useState<
    null | number
  >(null);

  // const [diagnoDetailsSummary, setDiagnoDetailsSummary] = useState<
  //   SessionDignosisType[]
  // >([]);

  let [treatmentDetailInfo, setTreatmentDetailInfo] = useState<any>({
    psychotherapy: "NA",
    substance_cessation: "NA",
    supportive_measures: "NA",
    pharmacotherapy: "NA",
    indication: "NA",
    fda_pregnancy_categories: "NA",
    breastfeeding_warnings: "NA",
    contraindications: "NA",
    age_warnings: "NA",
  });




  const handleViewMore = (menu: string) => {
    if (menu === "session_transcript") {
      setSessionTranscriptisExpanded((prev) => !prev);
      setCurrentExpandedReport(1);
    } else if (menu === "session_summary") {
      setsessionSummaryIsExpanded((prev) => !prev);
      setCurrentExpandedReport(2);
    } else if (menu === "diagosis") {
      setDiagnosisIsExpanded((prev) => !prev);
      setCurrentExpandedReport(3);
    } else if (menu === "treatment_plan") {
      setTreatmentPlanIsExpanded((prev) => !prev);
      setCurrentExpandedReport(4);
    }
  };

  const feedbackExpanded = (reportid: number) => {
    if (reportid === 1) {
      setSessionTranscriptisExpanded((prev) => !prev);
    } else if (reportid === 2) {
      setsessionSummaryIsExpanded((prev) => !prev);
      setSessionSummaryEditMode(false);
    } else if (reportid === 3) {
      setDiagnosisIsExpanded((prev) => !prev);
    } else if (reportid === 4) {
      setTreatmentPlanIsExpanded((prev) => !prev);
    }
  };

  useEffect(() => {
    getSessionDetails();
    fetchSessionTranscript();
    fetchSessionSummary();
    fetchSessionAIDATreatmentPlan();
    // fetchSessionAIDADignosis();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let sessionTranscriptAttemptCount = 0; // Initialize attempt counter
    let sessionSummaryAttemptCount = 0;
    // let sessionAIDADignosisAttemptCount = 0;
    let sessionTreatmentAttemptCount = 0;

    sessionTranscriptintervalIdRef.current = window.setInterval(async () => {
      sessionTranscriptAttemptCount++;

      const apiResponse = await fetchSessionTranscript();

      if (
        apiResponse ||
        sessionTranscriptAttemptCount >= sessionReportMaxAttemptCount
      ) {
        clearInterval(sessionTranscriptintervalIdRef.current!); // Clear interval after 10 attempts or success
        sessionTranscriptintervalIdRef.current = null; // Reset intervalRef
      }
    }, sessionAutoRefreshTiming); // 60000 milliseconds = 1 minute

    sessionSummaryintervalIdRef.current = window.setInterval(async () => {
      sessionSummaryAttemptCount++;

      const apiResponse = await fetchSessionSummary();
      fetchSessionAIDADignosis();

      if (
        apiResponse ||
        sessionSummaryAttemptCount >= sessionReportMaxAttemptCount
      ) {
        clearInterval(sessionSummaryintervalIdRef.current!); // Clear interval after 10 attempts or success
        sessionSummaryintervalIdRef.current = null; // Reset intervalRef
      }
    }, sessionAutoRefreshTiming); // 60000 milliseconds = 1 minute

    sessionTreatmentPlanintervalIdRef.current = window.setInterval(async () => {
      sessionTreatmentAttemptCount++;

      const apiResponse = await fetchSessionAIDATreatmentPlan();

      if (
        apiResponse ||
        sessionTreatmentAttemptCount >= sessionReportMaxAttemptCount
      ) {
        clearInterval(sessionTreatmentPlanintervalIdRef.current!); // Clear interval after 10 attempts or success
        sessionTreatmentPlanintervalIdRef.current = null; // Reset intervalRef
      }
    }, sessionAutoRefreshTiming); // 60000 milliseconds = 1 minute

    // Cleanup on unmount
    return () => {
      if (sessionTranscriptintervalIdRef.current !== null) {
        clearInterval(sessionTranscriptintervalIdRef.current);
      }

      if (sessionSummaryintervalIdRef.current !== null) {
        clearInterval(sessionSummaryintervalIdRef.current);
      }

      // if (sessionAIDADignosisintervalIdRef.current !== null) {
      //   clearInterval(sessionAIDADignosisintervalIdRef.current);
      // }

      if (sessionTreatmentPlanintervalIdRef.current !== null) {
        clearInterval(sessionTreatmentPlanintervalIdRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSessionTranscript = async () => {
    try {
      if (adminPractitionerId && role === "admin") {
        setDignosisLoading(true);
        const APIResponse = await getData(
          `/get-transcription/${adminPractitionerId}/${patientDetails.id}/${sessionid}`
        );
        return processSessionTranscriptAPIResponse(APIResponse);
      } else {
        setDignosisLoading(true);
        const APIResponse = await getData(
          `/get-transcription/${practionerDetails.practionerInfo.id}/${patientDetails.id}/${sessionid}`
        );
        return processSessionTranscriptAPIResponse(APIResponse);
      }
    } catch (error) {
      console.error("Error fetching the files:", error);
      return false; // Continue polling if there's an error
    }
  };

  // Function to process the API response
  const processSessionTranscriptAPIResponse = async (APIResponse: any) => {
    if (Array.isArray(APIResponse) && APIResponse.length > 0) {
      const mergedAudioSegments = APIResponse.flatMap(
        (item: { results: { audio_segments: any } }) =>
          item.results.audio_segments
      );
      if (mergedAudioSegments.length) {
        setSessionTranscriptList(mergedAudioSegments);
        return true; // API response is not empty
      } else {
        return false; // API response is empty
      }
    } else if (
      !Array.isArray(APIResponse) &&
      APIResponse !== null &&
      typeof APIResponse === "object"
    ) {
      const { download_url } = APIResponse;
      const transcriptResponse = await fetch(download_url);
      const transcriptData = await transcriptResponse.json();
      setSessionTranscriptList(transcriptData);
      return true; // API response is not empty
    }
    return false; // API response is empty
  };

  const getSessionDetails = async () => {
    try {
      if (adminPractitionerId && role === "admin") {
        const APIResponse = await getData(
          `/get-session/${adminPractitionerId}/${sessionid}`
        );
        if (APIResponse) {
          const result = splitDateTime(APIResponse.audio_created_at);
          const duration = findDuration(
            APIResponse.audio_created_at,
            APIResponse.session_end_dttm
          );
          if (duration) {
            setDuration(duration);
          }
          if (result && result.date && result.time) {
            setSessionDate(result.date);
            setSessionTime(result.time);
          }
        }
      } else {
        const APIResponse = await getData(
          `/get-session/${practionerDetails.practionerInfo.id}/${sessionid}`
        );
        if (APIResponse) {
          const duration = findDuration(
            APIResponse.audio_created_at,
            APIResponse.session_end_dttm
          );
          if (duration) {
            setDuration(duration);
          }
          const result = splitDateTime(APIResponse.audio_created_at);
          if (result && result.date && result.time) {
            setSessionDate(result.date);
            setSessionTime(result.time);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching the files:", error);
    }
  };

  const fetchSessionSummary = async () => {
    try {
      if (adminPractitionerId && role === "admin") {
        const APIResponse = await getData(
          `/get-summaries/${adminPractitionerId}/${patientDetails.id}/${sessionid}`
        );
        return processSessionSummaryAPIResponse(APIResponse);

        // return processSessionSummaryAPIResponse(staticSummaryApiResponse);
      } else {
        const APIResponse = await getData(
          `/get-summaries/${practionerDetails.practionerInfo.id}/${patientDetails.id}/${sessionid}`
        );
        return processSessionSummaryAPIResponse(APIResponse);
        // return processSessionSummaryAPIResponse(staticSummaryApiResponse);
      }
    } catch (error) {
      console.error("Error fetching the files:", error);
      return false; // Continue polling if there's an error
    }
  };

  const processSessionSummaryAPIResponse = (APIResponse: any): boolean => {
    setSessionSummaryAPIResponse(APIResponse);
    if (Array.isArray(APIResponse) && APIResponse.length > 0) {
      const sessionSummary = transformData(APIResponse);
      if (sessionSummary.length) {
        setSessionSummaryList(sessionSummary);
        setSessionSummaryData(sessionSummary);
        confirmSessionSummaryType(APIResponse);
        return true; // API response is not empty
      } else {
        return false; // API response is empty
      }
    } else if (
      !Array.isArray(APIResponse) &&
      APIResponse !== null &&
      typeof APIResponse === "object"
    ) {
      setSessionSummaryList([APIResponse]);
      setSessionSummaryData([APIResponse]);
      return true; // API response is not empty
    }
    return false; // API response is empty
  };

  const confirmSessionSummaryType = async (summaryData: SummaryEntry[]) => {
    try {
      // Find the "summary_general" entry
      const summaryGeneralEntry = summaryData.find(
        ([key]) => key === "summary_general"
      );
      // Extract the object if the entry is found
      const summaryGeneralValue = summaryGeneralEntry
        ? summaryGeneralEntry[1]
        : null;
      const summaryType =
        summaryGeneralValue?.patient_category?.[0] ?? "Mental";
      setSessionSummaryType(summaryType);

      // Find the "summary_sud" entry
      const summarySudEntry = summaryData.find(
        ([key]) => key === "summary_sud"
      );
      // Extract the object if the entry is found
      const summarySudValue = summarySudEntry ? summarySudEntry[1] : null;
      setSessionSummaryListData(summaryData);


      // Find the "summary_mdd" entry
      const summaryMddEntry = summaryData.find(
        ([key]) => key === "summary_mdd"
      );
      // Extract the object if the entry is found
      const summaryMddValue = summaryMddEntry ? summaryMddEntry[1] : null;

      // Find the "summary_ptsd" entry
      const summaryPtsdEntry = summaryData.find(
        ([key]) => key === "summary_ptsd"
      );
      // Extract the object if the entry is found
      const summaryPtsdValue = summaryPtsdEntry ? summaryPtsdEntry[1] : null;

      // Find the "summary_ptsd" entry
      const summaryGadEntry = summaryData.find(
        ([key]) => key === "summary_gad"
      );
      // Extract the object if the entry is found
      const summaryGadValue = summaryGadEntry ? summaryGadEntry[1] : null;

      // Find the "summary_sleep" entry
      const summarySleepEntry = summaryData.find(
        ([key]) => key === "summary_sleep"
      );
      // Extract the object if the entry is found
      const summarySleepValue = summarySleepEntry ? summarySleepEntry[1] : null;

      const sessionSummaryReportData =
      {
        summary_general: {
          sex: summaryGeneralValue?.["sex"] || [],
          age: summaryGeneralValue?.["age"] || [],
          chief_complaint: summaryGeneralValue?.[
            "chief_complaint"
          ] || [],
          history_of_present_illness: summaryGeneralValue?.[
            "history_of_present_illness"
          ] || [],
          past_psychiatric_history: summaryGeneralValue?.[
            "past_psychiatric_history"
          ] || [],
          past_psychiatric_medication: summaryGeneralValue?.[
            "past_psychiatric_medication"
          ] || [],
          cognitive_history: summaryGeneralValue?.[
            "cognitive_history"
          ] || [],
          cognitive_functioning: summaryGeneralValue?.[
            "cognitive_functioning"
          ] || [],
          mental_health: summaryGeneralValue?.["mental_health"] || [],
          other_mental_health:
            summaryGeneralValue?.[
            "other_mental_health"
            ] || [],
          child_trauma: summaryGeneralValue?.["child_trauma"] || [],
          cultural_belief: summaryGeneralValue?.["cultural_belief"] || [],
          family_history_medical: summaryGeneralValue?.[
            "family_history_medical"
          ] || [],
          education: summaryGeneralValue?.["education"] || [],
          employment: summaryGeneralValue?.["employment"] || [],
          relationship: summaryGeneralValue?.["relationship"] || [],
          friends: summaryGeneralValue?.["friends"] || [],
          support_system: summaryGeneralValue?.["support_system"] || [],
          stress_level: summaryGeneralValue?.["stress_level"] || [],
          trigger: summaryGeneralValue?.["trigger"] || [],
          diet_and_nutrition: summaryGeneralValue?.[
            "diet_and_nutrition"
          ] || [],
          sleep_pattern: summaryGeneralValue?.[
            "sleep_pattern"
          ] || [],
          physical_activity: summaryGeneralValue?.[
            "physical_activity"
          ] || [],
          daily_routine: summaryGeneralValue?.["daily_routine"] || [],
          energy_level: summaryGeneralValue?.["energy_level"] || [],
          hobbies_and_interests: summaryGeneralValue?.[
            "hobbies_and_interests"
          ] || [],
          self_care: summaryGeneralValue?.["self_care"] || [],
          suicide_attempt: summaryGeneralValue?.["suicide_attempt"] || [],
          suicide_ideation: summaryGeneralValue?.['suicide_ideation'] || [],
          past_medical_history: summaryGeneralValue?.['past_medical_history'] || [],
          medication_review: summaryGeneralValue?.['medication_review'] || [],
          physical_examination: summaryGeneralValue?.['physical_examination'] || [],
          framework: summaryGeneralValue?.['framework'] || [],
          recent_lab_work: summaryGeneralValue?.['recent_lab_work'] || [],
          mental_status_examination: summaryGeneralValue?.['mental_status_examination'] || [],
          review_of_systems: summaryGeneralValue?.['review_of_systems'] || [],
          liver_problem: summaryGeneralValue?.['liver_problem'] || [],
          heart_problem: summaryGeneralValue?.['heart_problem'] || [],
          thyroid_problem: summaryGeneralValue?.['thyroid_problem'] || [],
          adrenal_problem: summaryGeneralValue?.['adrenal_problem'] || [],
          neurological_problem: summaryGeneralValue?.['neurological_problem'] || [],
          inflammatory_autoimmune_problem: summaryGeneralValue?.['inflammatory_autoimmune_problem'] || [],
          hormonal_imbalances: summaryGeneralValue?.['hormonal_imbalances'] || [],
          gastrointestinal_problem: summaryGeneralValue?.['gastrointestinal_problem'] || [],
          infection: summaryGeneralValue?.['infection'] || [],
          diabetes_mellitus: summaryGeneralValue?.['diabetes_mellitus'] || [],
          vitamin_deficiency: summaryGeneralValue?.['vitamin_deficiency'] || [],
          diagnosis: summaryGeneralValue?.['diagnosis'] || [],
          secondary_diagnosis: summaryGeneralValue?.['secondary_diagnosis'] || [],
          risk_factor_assessment: summaryGeneralValue?.['risk_factor_assessment'] || [],
          plan: summaryGeneralValue?.['plan'] || [],
          allergies: summaryGeneralValue?.['allergies'] || [],
          pregnancy: summaryGeneralValue?.['pregnancy'] || [],
          other: summaryGeneralValue?.['other'] || [],
          insurance: summaryGeneralValue?.['insurance'] || [],
          firearm: summaryGeneralValue?.['firearm'] || [],
          safety: summaryGeneralValue?.['safety'] || [],
          violence: summaryGeneralValue?.['violence'] || [],
          legal_problem: summaryGeneralValue?.['legal_problem'] || [],
          reaction: summaryGeneralValue?.['reaction'] || [],
          visit_scenario: summaryGeneralValue?.['visit_scenario'] || [],
          medium: summaryGeneralValue?.['medium'] || [],
          interval_history: summaryGeneralValue?.['interval_history'] || [],
          gender_issue: summaryGeneralValue?.['gender_issue'] || [],
          self_perception_and_confidence: summaryGeneralValue?.['self_perception_and_confidence'] || [],
          chronic_pain: summaryGeneralValue?.['chronic_pain'] || [],
          hormonal_imbalnces: summaryGeneralValue?.['hormonal_imbalnces'] || [],
          vocabulary: summaryGeneralValue?.['vocabulary'] || []
        },
        summary_sud: {
          coping_strategy: summarySudValue?.["coping_strategy"] || [],
          substance: summarySudValue?.["substance"] || [],
          secondary_substances: summarySudValue?.["secondary_substances"] || [],
          substance_start: summarySudValue?.["substance_start"] || [],
          frequency: summarySudValue?.["frequency"] || [],
          administration: summarySudValue?.["administration"] || [],
          overdose: summarySudValue?.["overdose"] || [],
          past_coping_strategy: summarySudValue?.['past_coping_strategy'] || [],
          relapse: summarySudValue?.['relapse'] || [],
          withdrawal_symptoms: summarySudValue?.['withdrawal_symptoms'] || [],
          motivation: summarySudValue?.['motivation'] || [],
          readiness: summarySudValue?.['readiness'] || [],
          "1_dsm_control_usage": summarySudValue?.["1_dsm_control_usage"] || [],
          "2_dsm_control_desire": summarySudValue?.["2_dsm_control_desire"] || [],
          "3_dsm_control_commitment": summarySudValue?.["3_dsm_control_commitment"] || [],
          "4_dsm_control_arduous": summarySudValue?.["4_dsm_control_arduous"] || [],
          "5_dsm_social_failure": summarySudValue?.["5_dsm_social_failure"] || [],
          "6_dsm_social_persistence": summarySudValue?.["6_dsm_social_persistence"] || [],
          "7_dsm_social_decline": summarySudValue?.["7_dsm_social_decline"] || [],
          "8_dsm_risk_hazard": summarySudValue?.["8_dsm_risk_hazard"] || [],
          "9_dsm_risk_tenacity": summarySudValue?.["9_dsm_risk_tenacity"] || [],
          "10_dsm_tolerance": summarySudValue?.["10_dsm_tolerance"] || [],
          "10_a_dsm_tolerance_dosage_increase": summarySudValue?.[
            "10_a_dsm_tolerance_dosage_increase"
          ] || [],
          "11_dsm_withdrawal": summarySudValue?.["11_dsm_withdrawal"] || [],
          "11_a_dsm_withdrawal_relief": summarySudValue?.["11_a_dsm_withdrawal_relief"] || [],
          "11_b_dsm_withdrawal_symptoms": summarySudValue?.["11_b_dsm_withdrawal_symptoms"] ||
            [],
        },
        summary_mdd: {
          "15_mdd_episode_type": summaryMddValue?.["15_mdd_episode_type"] || [],
          "17a_mdd_remission_partial": summaryMddValue?.["17a_mdd_remission_partial"] || [],
          "17b_mdd_remission_full": summaryMddValue?.["17b_mdd_remission_full"] || [],
          "18_mdd_distress": summaryMddValue?.["18_mdd_distress"] || [],
          "19_mdd_mixed": summaryMddValue?.["19_mdd_mixed"] || [],
          "20_mdd_melancholic": summaryMddValue?.["20_mdd_melancholic"] || [],
          "21_mdd_atypical": summaryMddValue?.["21_mdd_atypical"] || [],
          "22_mdd_psychotic": summaryMddValue?.["22_mdd_psychotic"] || [],
          "23_mdd_catatonia": summaryMddValue?.["23_mdd_catatonia"] || [],
          "24_mdd_peripartum": summaryMddValue?.["24_mdd_peripartum"] || [],
          "25_mdd_seasonal": summaryMddValue?.["25_mdd_seasonal"] || [],
          "1_mdd_mood": summaryMddValue?.["1_mdd_mood"] || [],
          "2_mdd_interest": summaryMddValue?.["2_mdd_interest"] || [],
          "3_mdd_weight": summaryMddValue?.["3_mdd_weight"] || [],
          "4_mdd_insomnia": summaryMddValue?.["4_mdd_insomnia"] || [],
          "5_mdd_retardation": summaryMddValue?.["5_mdd_retardation"] || [],
          "6_mdd_fatigue": summaryMddValue?.["6_mdd_fatigue"] || [],
          "7_mdd_guilt": summaryMddValue?.["7_mdd_guilt"] || [],
          "8_mdd_concentration": summaryMddValue?.["8_mdd_concentration"] || [],
          "9_mdd_suicide": summaryMddValue?.["9_mdd_suicide"] || [],
          "10_mdd_symptom_count": summaryMddValue?.["10_mdd_symptom_count"] || [],
          "11_mdd_impairment": summaryMddValue?.["11_mdd_impairment"] || [],
          "12_mdd_exclusion_medical": summaryMddValue?.["12_mdd_exclusion_medical"] || [],
          "13_mdd_exclusion_schizo": summaryMddValue?.["13_mdd_exclusion_schizo"] || [],
          "14_mdd_hypomanic": summaryMddValue?.["14_mdd_hypomanic"] || [],
        },
        summary_ptsd: {
          "9_a_ptsd_dissociation_depersonalization": summaryPtsdValue?.[
            "9_a_ptsd_dissociation_depersonalization"
          ] || [],
          "9_b_ptsd_dissociation_derealization": summaryPtsdValue?.[
            "9_b_ptsd_dissociation_derealization"
          ] || [],
          "10_ptsd_delayed_expression": summaryPtsdValue?.["10_ptsd_delayed_expression"] || [],
          "1_ptsd_criterion_a": summaryPtsdValue?.["1_ptsd_criterion_a"] || [],
          "1_a_ptsd_exposure_direct": summaryPtsdValue?.["1_a_ptsd_exposure_direct"] || [],
          "1_b_ptsd_exposure_witnessing": summaryPtsdValue?.["1_b_ptsd_exposure_witnessing"] ||
            [],
          "1_c_ptsd_exposure_learning": summaryPtsdValue?.["1_c_ptsd_exposure_learning"] || [],
          "1_d_ptsd_exposure_aversive_details": summaryPtsdValue?.[
            "1_d_ptsd_exposure_aversive_details"
          ] || [],
          "2_ptsd_criterion_b": summaryPtsdValue?.["2_ptsd_criterion_b"] || [],
          "2_a_ptsd_intrusion_memories": summaryPtsdValue?.["2_a_ptsd_intrusion_memories"] ||
            [],
          "2_b_ptsd_intrusion_dreams": summaryPtsdValue?.["2_b_ptsd_intrusion_dreams"] || [],
          "2_c_ptsd_intrusion_flashbacks": summaryPtsdValue?.["2_c_ptsd_intrusion_flashbacks"] ||
            [],
          "2_d_ptsd_intrusion_distress": summaryPtsdValue?.["2_d_ptsd_intrusion_distress"] ||
            [],
          "2_e_ptsd_intrusion_reactions": summaryPtsdValue?.["2_e_ptsd_intrusion_reactions"] ||
            [],
          "3_ptsd_criterion_c": summaryPtsdValue?.["3_ptsd_criterion_c"] || [],
          "3_a_ptsd_avoidance_thoughts": summaryPtsdValue?.["3_a_ptsd_avoidance_thoughts"] ||
            [],
          "3_b_ptsd_avoidance_reminders": summaryPtsdValue?.["3_b_ptsd_avoidance_reminders"] ||
            [],
          "4_ptsd_criterion_d": summaryPtsdValue?.["4_ptsd_criterion_d"] || [],
          "4_a_ptsd_memory_loss": summaryPtsdValue?.["4_a_ptsd_memory_loss"] || [],
          "4_b_ptsd_negative_beliefs": summaryPtsdValue?.["4_b_ptsd_negative_beliefs"] || [],
          "4_c_ptsd_self_blame": summaryPtsdValue?.["4_c_ptsd_self_blame"] || [],
          "4_d_ptsd_emotional_state": summaryPtsdValue?.["4_d_ptsd_emotional_state"] || [],
          "4_e_ptsd_interest_loss": summaryPtsdValue?.["4_e_ptsd_interest_loss"] || [],
          "4_f_ptsd_detachment": summaryPtsdValue?.["4_f_ptsd_detachment"] || [],
          "4_g_ptsd_positive_emotions": summaryPtsdValue?.["4_g_ptsd_positive_emotions"] || [],
          "5_ptsd_criterion_e": summaryPtsdValue?.["5_ptsd_criterion_e"] || [],
          "5_a_ptsd_irritability": summaryPtsdValue?.["5_a_ptsd_irritability"] || [],
          "5_b_ptsd_reckless_behavior": summaryPtsdValue?.["5_b_ptsd_reckless_behavior"] || [],
          "5_c_ptsd_hypervigilance": summaryPtsdValue?.["5_c_ptsd_hypervigilance"] || [],
          "5_d_ptsd_startle_response": summaryPtsdValue?.["5_d_ptsd_startle_response"] || [],
          "5_e_ptsd_concentration": summaryPtsdValue?.["5_e_ptsd_concentration"] || [],
          "5_f_ptsd_sleep_disturbance": summaryPtsdValue?.["5_f_ptsd_sleep_disturbance"] || [],
          "6_ptsd_duration": summaryPtsdValue?.["6_ptsd_duration"] || [],
          "7_ptsd_impairment": summaryPtsdValue?.["7_ptsd_impairment"] || [],
          "8_ptsd_exclusion": summaryPtsdValue?.["8_ptsd_exclusion"] || [],
        },
        summary_gad: {
          "1_gad_symptom": summaryGadValue?.["1_gad_symptom"] || [],
          "3_gad_control_of_worry": summaryGadValue?.["3_gad_control_of_worry"] || [],
          "2_gad_physical_symptoms": summaryGadValue?.["2_gad_physical_symptoms"] || [],
          "4_gad_impairment": summaryGadValue?.["4_gad_impairment"] || [],
          "5a_gad_panic_exclusion": summaryGadValue?.["5a_gad_panic_exclusion"] || [],
          "5b_gad_social_anxiety_exclusion": summaryGadValue?.[
            "5b_gad_social_anxiety_exclusion"
          ] || [],
          "5c_gad_ocd_exclusion": summaryGadValue?.["5c_gad_ocd_exclusion"] || [],
          "5d_gad_medical_exclusion": summaryGadValue?.["5d_gad_medical_exclusion"] || [],
        },
        summary_sleep: {
          "1_insomnia_criterion_a": summarySleepValue?.["1_insomnia_criterion_a"] || [],
          "1_a_insomnia_difficulty_initiating_sleep": summarySleepValue?.[
            "1_a_insomnia_difficulty_initiating_sleep"
          ] || [],
          "1_b_insomnia_difficulty_maintaining_sleep": summarySleepValue?.[
            "1_b_insomnia_difficulty_maintaining_sleep"
          ] || [],
          "1_c_insomnia_early_morning_awakening": summarySleepValue?.[
            "1_c_insomnia_early_morning_awakening"
          ] || [],
          "2_insomnia_distress_impairment": summarySleepValue?.[
            "2_insomnia_distress_impairment"
          ] || [],
          "3_insomnia_frequency": summarySleepValue?.["3_insomnia_frequency"] || [],
          "4_insomnia_duration": summarySleepValue?.["4_insomnia_duration"] || [],
          "5_insomnia_opportunity": summarySleepValue?.["5_insomnia_opportunity"] || [],
          "6_insomnia_exclusion_other_disorders": summarySleepValue?.[
            "6_insomnia_exclusion_other_disorders"
          ] || [],
          "7_insomnia_exclusion_substances": summarySleepValue?.[
            "7_insomnia_exclusion_substances"
          ] || [],
          "8_insomnia_exclusion_medical_mental": summarySleepValue?.[
            "8_insomnia_exclusion_medical_mental"
          ] || [],
          "9_hypersomnolence_criterion_a": summarySleepValue?.["9_hypersomnolence_criterion_a"] ||
            [],
          "9_a_hypersomnolence_recurrent_sleep_periods": summarySleepValue?.[
            "9_a_hypersomnolence_recurrent_sleep_periods"
          ] || [],
          "9_b_hypersomnolence_prolonged_sleep": summarySleepValue?.[
            "9_b_hypersomnolence_prolonged_sleep"
          ] || [],
          "9_c_hypersomnolence_difficulty_awakening": summarySleepValue?.[
            "9_c_hypersomnolence_difficulty_awakening"
          ] || [],
          "10_hypersomnolence_frequency": summarySleepValue?.["10_hypersomnolence_frequency"] ||
            [],
          "11_hypersomnolence_distress_impairment": summarySleepValue?.[
            "11_hypersomnolence_distress_impairment"
          ] || [],
          "12_hypersomnolence_exclusion_other_disorders": summarySleepValue?.[
            "12_hypersomnolence_exclusion_other_disorders"
          ] || [],
          "13_hypersomnolence_exclusion_substances": summarySleepValue?.[
            "13_hypersomnolence_exclusion_substances"
          ] || [],
          "14_hypersomnolence_exclusion_medical_mental": summarySleepValue?.[
            "14_hypersomnolence_exclusion_medical_mental"
          ] || [],
          "15_a_hypersomnolence_severity_mild": summarySleepValue?.[
            "15_a_hypersomnolence_severity_mild"
          ] || [],
          "15_b_hypersomnolence_severity_moderate": summarySleepValue?.[
            "15_b_hypersomnolence_severity_moderate"
          ] || [],
          "15_c_hypersomnolence_severity_severe": summarySleepValue?.[
            "15_c_hypersomnolence_severity_severe"
          ] || [],
          "16_circadian_disruption": summarySleepValue?.["16_circadian_disruption"] || [],
          "17_circadian_sleepiness_insomnia": summarySleepValue?.[
            "17_circadian_sleepiness_insomnia"
          ] || [],
          "18_circadian_distress_impairment": summarySleepValue?.[
            "18_circadian_distress_impairment"
          ] || [],
          "19_circadian_exclusion_other_disorders": summarySleepValue?.[
            "19_circadian_exclusion_other_disorders"
          ] || [],
          "20_a_circadian_delayed_sleep_phase": summarySleepValue?.[
            "20_a_circadian_delayed_sleep_phase"
          ] || [],
          "20_c_circadian_irregular_sleep_wake": summarySleepValue?.[
            "20_c_circadian_irregular_sleep_wake"
          ] || [],
          "20_d_circadian_non_24_hour": summarySleepValue?.["20_d_circadian_non_24_hour"] || [],
          "20_e_circadian_shift_work": summarySleepValue?.["20_e_circadian_shift_work"] || [],
          "20_f_circadian_unspecified": summarySleepValue?.["20_f_circadian_unspecified"] || []
        }
      }
      setMentalSessionSummaryReportObject(sessionSummaryReportData);
      fetchSessionAIDADignosis();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSessionAIDADignosis = async () => {
    try {
      if (adminPractitionerId && role === "admin") {
        setDignosisLoading(true);
        const APIResponse = await getData(
          `/get-diagnosis/${adminPractitionerId}/${patientDetails.id}/${sessionid}`
        );
        return processSessionAIDADignosisAPIResponse(APIResponse);
        // return processSessionAIDADignosisAPIResponse(
        //   staticDignosisAPIResponseFormat
        // );
      } else {
        setDignosisLoading(true);
        const APIResponse = await getData(
          `/get-diagnosis/${practionerDetails.practionerInfo.id}/${patientDetails.id}/${sessionid}`
        );
        return processSessionAIDADignosisAPIResponse(APIResponse);
        // return processSessionAIDADignosisAPIResponse(
        //   staticDignosisAPIResponseFormat
        // );
      }
    } catch (error) {
      console.error("Error fetching the files:", error);
      return false; // Continue polling if there's an error
    }
  };

  const handleSessionSummaryInputChange = (keyWithIndex: string, value: string, section: string) => {
    console.log(keyWithIndex, value, section)
    const match = keyWithIndex.match(/(.*)\[(\d+)\]/);
    if (match) {
      const key = match[1];
      const index = parseInt(match[2]);
      setMentalSessionSummaryReportObject((prev: { [x: string]: any; }) => {
        const updatedArray = [...prev[section][key]];
        updatedArray[index] = value;
        return {
          ...prev,
          [section]: {
            ...prev[section],
            [key]: updatedArray
          }
        };
      });
    } else {
      setMentalSessionSummaryReportObject((prev: { [x: string]: any; }) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [keyWithIndex]: [value]
        }
      }));
    }
  }

  const processSessionAIDADignosisAPIResponse = (APIResponse: any): boolean => {
    if (Array.isArray(APIResponse) && APIResponse.length > 0) {
      // Initialize dignosisReportObject with the original API response
      console.log("🔥 INITIALIZING DIAGNOSIS OBJECT:", APIResponse);
      setdignosisReportObject(APIResponse);

      const sessionDignosis = transformData(APIResponse);
      if (sessionDignosis.length) {
        let principalClinicalFindingsList: any = [];
        // eslint-disable-next-line array-callback-return
        Object.entries(sessionDignosis[2]).map(
          // eslint-disable-next-line array-callback-return
          ([key, value]: [string, any]) => {
            principalClinicalFindingsList = [value];
          }
        );
        console.log("🔥 PRINCIPAL CLINICAL FINDINGS:", principalClinicalFindingsList);
        console.log("🔥 SUD DATA IN DIAGNOSIS:", principalClinicalFindingsList[0]?.sud);
        setPrincipalClinicalFindingsList(principalClinicalFindingsList);

        // Create diagnosis display object using actual diagnosis field names
        const diagnosisData = principalClinicalFindingsList[0];
        if (diagnosisData) {
          const diagnosisDisplayData = {
            summary_sud: diagnosisData.sud || {},
            summary_mdd: diagnosisData.mdd || {},
            summary_gad: diagnosisData.gad || {},
            summary_ptsd: diagnosisData.ptsd || {},
            summary_sleep: diagnosisData.sleep || {}
          };
          console.log("🔥 DIAGNOSIS DISPLAY OBJECT:", diagnosisDisplayData);
          console.log("🔥 MAIN SUBSTANCE VALUE:", diagnosisDisplayData.summary_sud?.main_substance);
          setDiagnosisDisplayObject(diagnosisDisplayData);
        }
        setDiagnosisList(sessionDignosis);
        prepareDiagnosisData(sessionDignosis, principalClinicalFindingsList);
        return true; // API response is not empty
      } else {
        return false; // API response is not empty
      }
    } else if (
      !Array.isArray(APIResponse) &&
      APIResponse !== null &&
      typeof APIResponse === "object"
    ) {
      // Initialize dignosisReportObject with the original API response
      setdignosisReportObject(APIResponse);

      setDiagnosisList([APIResponse]);
      prepareDiagnosisData([APIResponse], principalClinicalFindingsList);
      return true; // API response is not empty
    }
    return false; // API response is empty
  };

  const fetchSessionAIDATreatmentPlan = async () => {
    try {
      if (adminPractitionerId && role === "admin") {
        const APIResponse = await getData(
          `/get-treatment/${adminPractitionerId}/${patientDetails.id}/${sessionid}`
        );
        return processSessionAIDATreatmenPlantAPIResponse(APIResponse);
      } else {
        const APIResponse = await getData(
          `/get-treatment/${practionerDetails.practionerInfo.id}/${patientDetails.id}/${sessionid}`
        );
        return processSessionAIDATreatmenPlantAPIResponse(APIResponse);
      }
    } catch (error) {
      console.error("Error fetching the files:", error);
      return false; // Continue polling if there's an error
    }
  };

  const processSessionAIDATreatmenPlantAPIResponse = (
    APIResponse: any
  ): boolean => {
    if (Array.isArray(APIResponse) && APIResponse.length > 0) {
      // Initialize treatmentReportObject with the original API response
      console.log("🔥 INITIALIZING TREATMENT OBJECT:", APIResponse);
      setTreatmentReportObject(APIResponse);

      const isNoTreatment = checkNoTreatement(APIResponse);
      const treatmentPlan = transformData(APIResponse);
      if (isNoTreatment) {
        setTreatmentPlanList(treatmentPlan);
        setTreatmentPlanData(treatmentPlan);
        return true; // No Need call Chunking API
      }
      if (treatmentPlan.length) {
        setTreatmentPlanList(treatmentPlan);
        setTreatmentPlanData(treatmentPlan);
        return true; // API response is not empty
      } else {
        return false;
      }
    } else if (
      !Array.isArray(APIResponse) &&
      APIResponse !== null &&
      typeof APIResponse === "object"
    ) {
      // Initialize treatmentReportObject with the original API response
      console.log("🔥 INITIALIZING TREATMENT OBJECT:", APIResponse);
      setTreatmentReportObject(APIResponse);

      setTreatmentPlanList([APIResponse]);
      setTreatmentPlanData(treatmentPlanList);
      return true; // API response is not empty
    }
    return false; // API response is empty
  };

  const transformData = (input: DataItem[]): DataItem[] => {
    return input.reduce((acc: DataItem[], obj: DataItem) => {
      Object.keys(obj).forEach((key: string) => {
        acc.push({ [key]: obj[key] });
      });
      return acc;
    }, []);
  };

  const setSessionSummaryData = (sessionSummary: any) => {
    let identiObj: any = {};
    let patientObj: any = {};
    let substanceObj: any = {};
    let diagnosObj: any = {};
    let treatmentObj: any = {};
    let aidaTouchObj: any = {};
    let priDiagnoObj: any = {};
    // let obj = {};
    sessionSummary.map((sessionData: any) => {
      Object.entries(sessionData).map(([key, value]) => {
        if (key === "visit") {
          identiObj["visit"] = value;
        }
        if (key === "education") {
          identiObj["education"] = value;
        }
        if (key === "employment") {
          identiObj["employment"] = value;
        }
        if (key === "complaint") {
          patientObj["complaint"] = value;
        }
        if (key === "firearm") {
          patientObj["firearm"] = value;
        }
        if (key === "legal_problem") {
          patientObj["legal_problem"] = value;
        }
        if (key === "past_psychiatric_history") {
          patientObj["past_psychiatric_history"] = value;
        }
        if (key === "violence") {
          patientObj["violence"] = value;
        }
        if (key === "gender_issue") {
          patientObj["gender_issue"] = value;
        }
        if (key === "child_trauma") {
          patientObj["child_trauma"] = value;
        }
        if (key === "relationship") {
          patientObj["relationship"] = value;
        }
        if (key === "friends") {
          patientObj["friends"] = value;
        }
        if (key === "previous_medical_history") {
          patientObj["previous_medical_history"] = value;
        }
        if (key === "liver_problem") {
          patientObj["liver_problem"] = value;
        }
        if (key === "heart_problem") {
          patientObj["heart_problem"] = value;
        }
        if (key === "vitamin_deficiency") {
          patientObj["vitamin_deficiency"] = value;
        }
        if (key === "infection") {
          patientObj["infection"] = value;
        }
        if (key === "drug_allergy") {
          patientObj["drug_allergy"] = value;
        }
        if (key === "medicaiton") {
          patientObj["medicaiton"] = value;
        }
        if (key === "mental_health") {
          patientObj["mental_health"] = value;
        }
        if (key === "other_mental_health") {
          patientObj["other_mental_health"] = value;
        }
        if (key === "cognitive_history") {
          patientObj["cognitive_history"] = value;
        }
        if (key === "cognitive_functioning") {
          patientObj["cognitive_functioning"] = value;
        }
        if (key === "suicide_attempt") {
          patientObj["suicide_attempt"] = value;
        }
        if (key === "suicide_ideation") {
          patientObj["suicide_ideation"] = value;
        }
        if (key === "safety") {
          patientObj["safety"] = value;
        }

        if (key === "substance") {
          substanceObj["substance"] = value;
        }
        if (key === "secondary_substances") {
          substanceObj["secondary_substances"] = value;
        }
        if (key === "frequency") {
          substanceObj["frequency"] = value;
        }
        if (key === "administration") {
          substanceObj["administration"] = value;
        }
        if (key === "substance_start") {
          substanceObj["substance_start"] = value;
        }
        if (key === "chronic_pain") {
          substanceObj["chronic_pain"] = value;
        }
        if (key === "cultural_belief") {
          substanceObj["cultural_belief"] = value;
        }
        if (key === "motivation") {
          substanceObj["motivation"] = value;
        }
        if (key === "readiness") {
          substanceObj["readiness"] = value;
        }
        if (key === "coping_strategy") {
          substanceObj["coping_strategy"] = value;
        }
        if (key === "past_coping_strategy") {
          substanceObj["past_coping_strategy"] = value;
        }
        if (key === "withdrawal") {
          substanceObj["withdrawal"] = value;
        }
        if (key === "relapse") {
          substanceObj["relapse"] = value;
        }
        if (key === "overdose") {
          substanceObj["overdose"] = value;
        }

        if (key === "framework") {
          diagnosObj["framework"] = value;
        }
        if (key === "diagnosis") {
          diagnosObj["diagnosis"] = value;
        }
        if (key === "secondary_diagnosis") {
          diagnosObj["secondary_diagnosis"] = value;
        }
        if (key === "lab_work") {
          diagnosObj["lab_work"] = value;
        }

        if (key === "treatment") {
          treatmentObj["treatment"] = value;
        }
        if (key === "medicaiton") {
          treatmentObj["medicaiton"] = value;
        }
        if (key === "pregnancy") {
          treatmentObj["pregnancy"] = value;
        }
        if (key === "follow_up") {
          treatmentObj["follow_up"] = value;
        }

        if (key === "vocabulary") {
          aidaTouchObj["vocabulary"] = value;
        }

        if (key === "1_dsm_control_usage") {
          priDiagnoObj["1_dsm_control_usage"] = value;
        }
        if (key === "2_dsm_control_desire") {
          priDiagnoObj["2_dsm_control_desire"] = value;
        }
        if (key === "3_dsm_control_commitment") {
          priDiagnoObj["3_dsm_control_commitment"] = value;
        }
        if (key === "4_dsm_control_arduous") {
          priDiagnoObj["4_dsm_control_arduous"] = value;
        }
        if (key === "5_dsm_social_failure") {
          priDiagnoObj["5_dsm_social_failure"] = value;
        }
        if (key === "6_dsm_social_persistence") {
          priDiagnoObj["6_dsm_social_persistence"] = value;
        }
        if (key === "7_dsm_social_decline") {
          priDiagnoObj["7_dsm_social_decline"] = value;
        }
        if (key === "8_dsm_risk_hazard") {
          priDiagnoObj["8_dsm_risk_hazard"] = value;
        }
        if (key === "9_dsm_risk_tenacity") {
          priDiagnoObj["9_dsm_risk_tenacity"] = value;
        }
        if (key === "10_dsm_tolerance") {
          priDiagnoObj["10_dsm_tolerance"] = value;
        }
        if (key === "10_a_dsm_tolerance_dosage_increase") {
          priDiagnoObj["10_a_dsm_tolerance_dosage_increase"] = value;
        }
        if (key === "10_b_dsm_tolerance_tolerance") {
          priDiagnoObj["10_b_dsm_tolerance_tolerance"] = value;
        }
        if (key === "10_c_dsm_tolerance_symptoms") {
          priDiagnoObj["10_c_dsm_tolerance_symptoms"] = value;
        }
        if (key === "11_dsm_withdrawal") {
          priDiagnoObj["11_dsm_withdrawal"] = value;
        }
        if (key === "11_a_dsm_withdrawal_relief") {
          priDiagnoObj["11_a_dsm_withdrawal_relief"] = value;
        }
        if (key === "11_b_dsm_withdrawal_symptoms") {
          priDiagnoObj["11_b_dsm_withdrawal_symptoms"] = value;
        }
        return sessionData;
      });
      return sessionData;
    });
    // identInfo = identiObj;
    // patientInfo = patientObj;
    // substanceInfo = substanceObj;
    // treatmentInfo = treatmentObj;
    // diagnosInfo = diagnosObj;
    // aidaTouchInfo = aidaTouchObj;
    // priDiagnoRefInfo = priDiagnoObj;
    // setIdentInfo(identiObj);
    // setPatientInfo(patientObj);
    // setSubstanceInfo(substanceObj);
    // setDiagnosInfo(diagnosObj);
    // setTreatmentInfo(treatmentObj);
    // setAidaTouchInfo(aidaTouchObj);
    // setPriDiagnoRefInfo(priDiagnoObj);
  };

  const prepareDiagnosisData = (
    diagnosisData: any,
    principalClinicalFindingsList: any
  ) => {
    const sortOrder = ["mdd", "gad", "sud", "sud-induced", "ptsd", "sleep"];
    let primaryDignosisarray: any = [];
    let availableDignosisTypeListArray: String[] = [];
    principalClinicalFindingsList.map((diagnosisData: any) => {
      const keysWithMultipleChildren: { parentKey: string; value: any }[] = [];
      // eslint-disable-next-line array-callback-return
      Object.entries(diagnosisData).map(([key, value]: [string, any]) => {
        if (typeof value === "object" && value !== null) {
          const diagnosisArray = value?.diagnosis || [];
          if (diagnosisArray.length) {
            availableDignosisTypeListArray.push(key);
            let disorder: any = [];
            let code: any = [];
            let severity: any = [];
            // eslint-disable-next-line array-callback-return
            diagnosisArray.map((diagno: any) => {
              if (diagno.disorder || diagno.code || diagno.severity) {
                disorder = [...disorder, diagno.disorder];
                code = [...code, diagno.code];
                severity = [...severity, diagno.severity];
                diagno.type = key;
                primaryDignosisarray.push(diagno);
                return diagno;
              }
            });
          }
        }
      });
      return keysWithMultipleChildren;
    });


    primaryDignosisarray.sort((a: { type: string }, b: { type: string }) => {
      return sortOrder.indexOf(a.type) - sortOrder.indexOf(b.type);
    });

    // setDiagnoDetailsSummary(primaryDignosisarray);


    // Find "Principal" values
    const principalValues = diagnosisData
      .map((item: { Principal: any }) => item.Principal) // Get "Principal" key values
      .filter(Boolean) // Remove undefined values
      .flat(); // Flatten nested arrays
    setDignosisPrincipalList(principalValues);

    // Find "Subthreshold" values
    const subthresholdValues = diagnosisData
      .map((item: { Subthreshold: any }) => item.Subthreshold) // Get "Principal" key values
      .filter(Boolean) // Remove undefined values
      .flat(); // Flatten nested arrays
    setDignosisSubthresholdList(subthresholdValues);
    setDignosisLoading(false);
  };


  const setTreatmentPlanData = (treatmentPlan: any) => {
    let treatmentDetailObj: any = {};
    let psychotherapy: any = [];
    let pharmacotherapy: any = [];
    let substance_cessation: any = [];
    let indication: any = [];
    let fda_pregnancy_categories: any = [];
    let supportive_measures: any = [];
    let breastfeeding_warnings: any = [];
    let contraindications: any = [];
    let age_warnings: any = [];
    let pharmacologicalMedicationData: any[] = [];
    let nonPharmacologicalMedicationData: any[] = [];
    Object.values(treatmentPlan).map((obj: any) => {
      Object.entries(obj).map(([key, value]: any) => {
        const tmpObj: any = {};
        tmpObj.code = key;
        if (value.psychotherapy !== "N/A") {
          tmpObj.psychotherapy = value.psychotherapy;
          psychotherapy = [...psychotherapy, value.psychotherapy];
        }
        if (value.substance_cessation !== "N/A") {
          tmpObj.substance_cessation = value.substance_cessation;
          substance_cessation = [
            ...substance_cessation,
            value.substance_cessation,
          ];
        }
        if (value.supportive_measures !== "N/A") {
          tmpObj.supportive_measures = value.supportive_measures;
          supportive_measures = [
            ...supportive_measures,
            value.supportive_measures,
          ];
        }
        if (
          value?.medication &&
          value?.medication &&
          value?.medication.length > 0
        ) {
          value?.medication.map((medica: any) => {
            medica.code = key;
            pharmacologicalMedicationData.push(medica);
            pharmacotherapy = [...pharmacotherapy, medica.pharmacotherapy];
            indication = [...indication, medica.indication];
            fda_pregnancy_categories = [
              ...fda_pregnancy_categories,
              medica.fda_pregnancy_categories,
            ];
            breastfeeding_warnings = [
              ...breastfeeding_warnings,
              medica.breastfeeding_warnings,
            ];
            contraindications = [
              ...contraindications,
              medica.contraindications,
            ];
            age_warnings = [...age_warnings, medica.age_warnings];
            return medica;
          });
          nonPharmacologicalMedicationData.push(tmpObj);
        }
        return value;
      });
      return obj;
    });
    treatmentDetailObj.psychotherapy = psychotherapy;
    treatmentDetailObj.substance_cessation = substance_cessation;
    treatmentDetailObj.supportive_measures = supportive_measures;
    treatmentDetailObj.supportive_measures = psychotherapy;
    treatmentDetailObj.pharmacotherapy = pharmacotherapy;
    treatmentDetailObj.indication = indication;
    treatmentDetailObj.fda_pregnancy_categories = fda_pregnancy_categories;
    treatmentDetailObj.breastfeeding_warnings = breastfeeding_warnings;
    treatmentDetailObj.contraindications = contraindications;
    treatmentDetailObj.age_warnings = age_warnings;
    treatmentDetailInfo = treatmentDetailObj;
    setpharmacologicalMedicationList(pharmacologicalMedicationData);
    setNonPharmacologicalMedicationList(nonPharmacologicalMedicationData);
    setTreatmentDetailInfo(treatmentDetailObj);
  };

  const checkNoTreatement = (response: any) => {
    const expectedResponse = [
      {
        Treatment:
          "There is currently no treatment plan available for this session.",
      },
    ];
    const isSameResponse =
      JSON.stringify(response) === JSON.stringify(expectedResponse);

    return isSameResponse;
  };

  const downloadTxtFile = (menu: string) => {
    // Step 1: Create the content for the file
    // Create text content dynamically using map
    let content = "";
    let fileName = "sample.txt";
    if (menu === "session_transcript") {
      content = sessionTranscriptList
        .map((item, i) => `${item.speaker}: ${item.text}`)
        .join("\n"); // Join each transcript item with a new line

      fileName = `${patientDetails.first_name}-${patientDetails.last_name} SessionTranscript.txt`;
    } else if (menu === "session_treatment_plan") {
      content =
        document.getElementById("sessionTreatmentPlanDiv")?.innerText ||
        "There is No Session Treatement found.";

      fileName = `${patientDetails.first_name}-${patientDetails.last_name} AIDATreatmentPlan.txt`;
    } else if (menu === "session_summary") {
      content =
        document.getElementById("sessionSummaryDiv")?.innerText ||
        "There is No Session Summary found.";
      fileName = `${patientDetails.first_name}-${patientDetails.last_name} Session-Notes.txt`;
    } else if (menu === "aida_dignosis") {
      content =
        document.getElementById("sessionDignosisDiv")?.innerText ||
        "There is No Session Dignosis found.";

      fileName = `${patientDetails.first_name}-${patientDetails.last_name} AIDA-Diagnosis.txt`;
    }

    // Step 2: Create a Blob object with the content as plain text
    const blob = new Blob([content], { type: "text/plain" });

    // Step 3: Create a URL for the Blob
    const fileUrl = URL.createObjectURL(blob);

    // Step 4: Create an anchor element and simulate a click
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName; // Name of the file with .txt extension
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(fileUrl); // Revoke the object URL after download
  };

  const handleBack = () => {
    // Exit edit modes and repopulate with original data
    if (sessionSummaryIsExpanded) {
      if (sessionSummaryEditMode) {
        handleSessionSummaryCloseMode();
        // Repopulate summary with original data
        fetchSessionSummary();
      }
      setsessionSummaryIsExpanded(false);
    } else if (diagnosisIsExpanded) {
      if (assessmentRecommendationEditMode) {
        handleAssessmentRecommendationCloseMode();
        // Repopulate diagnosis with original data
        fetchSessionAIDADignosis();
      }
      setDiagnosisIsExpanded(false);
    } else if (treatmentIsExpanded) {
      if (TreatmenteditMode) {
        handleTreatmentCloseMode();
        // Repopulate treatment with original data
        fetchSessionAIDATreatmentPlan();
      }
      setTreatmentPlanIsExpanded(false);
    } else {
      if (sessionTranscriptEditMode) {
        handleSessionTranscriptCloseMode();
        // Repopulate transcript with original data
        fetchSessionTranscript();
      }
      setSessionTranscriptisExpanded(false);
    }

    if (
      !sessionSummaryIsExpanded &&
      !diagnosisIsExpanded &&
      !treatmentIsExpanded &&
      !sessionTranscriptisExpanded
    ) {
      navigate("/patient-details", {
        state: { patientDetails: patientDetails },
      });
    }
  };

  const handleSessionSummaryEditMode = () => {
    setSessionSummaryEditMode(true);
    setsessionSummaryIsExpanded(true);
    setCurrentExpandedReport(2);
  }

  const handleSessionSummaryCloseMode = () => {
    setSessionSummaryEditMode(false);
    // setSessionSummaryUpdate(false);
  }

  const handleAssessmentRecommendationEditMode = () => {
    setAssessmentRecommendationEditMode(true);
    setDiagnosisIsExpanded(true);
    setCurrentExpandedReport(3);
  }

  const handleAssessmentRecommendationCloseMode = () => {
    setAssessmentRecommendationEditMode(false);
    // setAssessmentRecommendationUpdate(false);
  }




  const handleSessionTranscriptEditMode = () => {
    setSessionTranscriptEditMode(true);
    setSessionTranscriptisExpanded(true);
    setCurrentExpandedReport(1);
  }

  const handleSessionTranscriptCloseMode = () => {
    setSessionTranscriptEditMode(false);
    // setSessionSummaryUpdate(false);
  }

  const handleTreatmentEditMode = () => {
    setTreatmentEditMode(true)
    setTreatmentPlanIsExpanded(true);
    setCurrentExpandedReport(4);
  }

  const handleTreatmentCloseMode = () => {
    setTreatmentEditMode(false);
    // setSessionSummaryUpdate(false);
  }

  return (
    <AppDrawer>
      <Paper
        variant="outlined"
        component="fieldset"
        sx={{
          backgroundColor: "#ffcc00",
          borderRadius: "10px",
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 3, fontSize: "medium" }}
            >
              {patientDetails?.first_name ? patientDetails.first_name : "-"}{" "}
              {patientDetails?.last_name ? patientDetails.last_name : "-"}
              <Divider
                sx={{ backgroundColor: "#ffcc00", borderBottomWidth: 2 }}
              ></Divider>
            </Typography>
          </Grid>
          <Grid item>
            <Button
              size="small"
              variant="contained"
              startIcon={<ArrowBack />}
              style={{
                backgroundColor: "#ffcc00",
                borderRadius: "05px",
                border: "1px solid black",
                color: "black",
              }}
              onClick={handleBack}
            >
              Back
            </Button>
          </Grid>
        </Grid>
        <Box height={10}></Box>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={3}
          sx={{ fontWeight: "bold", fontSize: "small" }}
        >
          <Grid item xs={3}>
            Initial Consultation Date
          </Grid>
          <Grid item xs={3}>
            Appointment Time
          </Grid>

          <Grid item xs={2}>
            Appointment Date
          </Grid>
          <Grid item xs={2}>
            Duration
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={3}
        >
          <Grid item xs={3} sx={{ fontSize: "small" }}>
            {sessionDate}
          </Grid>
          <Grid item xs={3} sx={{ fontSize: "small" }}>
            {sesssionTime}
          </Grid>

          <Grid item xs={2} sx={{ fontSize: "small" }}>
            {sessionDate}
          </Grid>
          <Grid item xs={2} sx={{ fontSize: "small" }}>
            {duration} Min
          </Grid>
        </Grid>
      </Paper>
      <Box height={10}></Box>
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        AIDA Reports
      </Typography>
      <Box height={10}></Box>

      <Grid container spacing={2}>
        {/* Session Summary */}
        {!sessionTranscriptisExpanded &&
          !diagnosisIsExpanded &&
          !treatmentIsExpanded && (
            <Grid item xs={12} md={sessionSummaryIsExpanded ? 12 : 6}>
              <Paper
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: sessionSummaryIsExpanded ? "300px" : "268px",
                  transition: "all 0.3s ease",
                  border: "1px solid #cfcfcf",
                }}
              >
                <Box sx={{ flex: "1 0 auto", p: 2 }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <Grid container spacing={2} justifyContent="flex-start">
                        <Grid item>
                          <IconButton
                            sx={{
                              borderRadius: "50%",
                              backgroundColor: "#ffcc00",
                              fontSize: "small",
                              cursor: "default",
                              "&:hover": {
                                backgroundColor: "#ffcc00", // Keeps the background color the same on hover
                              },
                            }}
                          >
                            <Chat sx={{ fontSize: "small", color: "black" }} />
                          </IconButton></Grid>
                        <Grid item><Typography sx={{ fontWeight: "bold" }}>
                          Session Summary
                        </Typography>
                        </Grid>
                        <Grid item>
                          <div>
                            <CachedIcon
                              onClick={fetchSessionSummary}
                              style={{ cursor: "pointer" }}
                            />
                          </div></Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      {
                        sessionSummaryEditMode ?
                          <CloseIcon
                            onClick={handleSessionSummaryCloseMode}
                            style={{ cursor: "pointer" }} /> :
                          <EditIcon
                            onClick={handleSessionSummaryEditMode}
                            style={{ cursor: "pointer" }} />

                      }
                    </Grid>
                  </Grid>
                  <Box height={10}></Box>
                  <Typography
                    variant="body2"
                    component="div"
                    id="sessionSummaryDiv"
                    sx={{
                      flex: 1,
                      minHeight: "150px",
                      maxHeight: sessionSummaryIsExpanded ? "300px" : "50px",
                      overflowY: sessionSummaryIsExpanded ? "auto" : "hidden",
                      transition: "max-height 0.3s ease",
                      overflowX: "hidden",
                    }}
                  >
                    {sessionSummaryListData &&
                      sessionSummaryType?.trim() !== "" &&
                      (sessionSummaryType === "Non_Mental" ? (
                        <NonMentalSessionSummary />
                      ) : (
                        <MentalSessionSummary
                          mentalSessionSummaryReportObject={mentalSessionSummaryReportObject}
                          isEdit={sessionSummaryEditMode}
                          handleInputChange={handleSessionSummaryInputChange}
                        />
                      ))}

                    {sessionSummaryListData &&
                      sessionSummaryType?.trim() === "" && <LoadingReport />}

                    {sessionSummaryLoading && (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ mt: 3 }}
                      >
                        <CircularProgress />
                      </Box>
                    )}
                  </Typography>
                </Box>

                {!sessionSummaryIsExpanded &&
                  !sessionSummaryLoading &&
                  sessionSummaryList.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "auto",
                        p: 1,
                      }}
                    >
                      <Button
                        size="small"
                        startIcon={<VisibilityIcon sx={{ color: "#ffcc00" }} />}
                        onClick={() => handleViewMore("session_summary")}
                        sx={{ textTransform: "none", color: "black" }}
                      >
                        {sessionSummaryIsExpanded ? "View Less" : "View More"}
                      </Button>
                      <Button
                        size="small"
                        endIcon={<DownloadIcon />}
                        sx={{ textTransform: "none", color: "black" }}
                        onClick={() => downloadTxtFile("session_summary")}
                      >
                        Download
                      </Button>
                    </Box>
                  )}
                {sessionSummaryEditMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      p: 1,
                      gap: 1,
                    }}
                  >
                    {/* <Button
                      size="small"
                      color="inherit"
                      variant="outlined"
                      onClick={handleCancel}
                      sx={{ textTransform: "none", color: "black" }}
                    >
                      Cancel
                    </Button> */}
                    <LoadingButton
                      size="small"
                      color="primary"
                      variant="contained"
                      sx={commonBtnStyle}
                      disabled={isReportButtonDisabledDueToLoading}
                      loading={isReportButtonDisabledDueToLoading}
                      onClick={() => handleReportUpdate('summary')}
                    >
                      Update
                    </LoadingButton>

                  </Box>
                )}
              </Paper>

              {/* Feedback */}
              {sessionSummaryIsExpanded && (
                <SessionFeedback
                  sessionid={sessionid}
                  reportid={currentExpandedReport}
                  feedbackExpanded={feedbackExpanded}
                />
              )}
            </Grid>
          )}

        {/* AIDA Diagnosis Recommendation */}
        {!sessionTranscriptisExpanded &&
          !sessionSummaryIsExpanded &&
          !treatmentIsExpanded && (
            <Grid item xs={12} md={diagnosisIsExpanded ? 12 : 6}>
              <Paper
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: diagnosisIsExpanded ? "300px" : "268px",
                  transition: "all 0.3s ease",
                  border: "1px solid #cfcfcf",
                }}
              >
                <Box sx={{ flex: "1 0 auto", p: 2 }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <Grid container spacing={2} justifyContent="flex-start">
                        <Grid item>
                          <IconButton
                            sx={{
                              borderRadius: "50%",
                              backgroundColor: "#ffcc00",
                              fontSize: "small",
                              cursor: "default",
                              "&:hover": {
                                backgroundColor: "#ffcc00", // Keeps the background color the same on hover
                              },
                            }}
                          >
                            <Chat sx={{ fontSize: "small", color: "black" }} />
                          </IconButton></Grid>
                        <Grid item><Typography sx={{ fontWeight: "bold" }}>
                          Assessment Recommendation Details & Insights
                        </Typography>
                        </Grid>
                        <Grid item>
                          <div>
                            <CachedIcon
                              onClick={fetchSessionAIDADignosis}
                              style={{ cursor: "pointer" }}
                            />
                          </div></Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      {
                        assessmentRecommendationEditMode ?
                          <CloseIcon
                            onClick={handleAssessmentRecommendationCloseMode}
                            style={{ cursor: "pointer" }} /> :
                          <EditIcon
                            onClick={handleAssessmentRecommendationEditMode}
                            style={{ cursor: "pointer" }} />

                      }
                    </Grid>
                  </Grid>

                  <Box height={10}></Box>
                  <Typography
                    variant="body2"
                    component="div"
                    id="sessionDignosisDiv"
                    sx={{
                      flex: 1, // Makes it fill the available space
                      minHeight: "150px", // Set minimum height for the transcript
                      maxHeight: diagnosisIsExpanded ? "300px" : "150px", // Expand/Collapse max height
                      overflowY: diagnosisIsExpanded ? "auto" : "hidden",
                      transition: "max-height 0.3s ease", // Smooth transition when expanding/collapsing
                      overflowX: "hidden",
                    }}
                  >
                    {sessionSummaryListData.length > 0 &&
                      diagnosisList.length > 0 &&
                      (dignosisPrincipalList.length > 0 ||
                        dignosisSubthresholdList.length > 0) && (
                        <AssessmentRecommendation
                          dignosisPrincipalList={dignosisPrincipalList}
                          principalClinicalFindingsList={
                            principalClinicalFindingsList
                          }
                          mentalSessionSummaryReportObject={diagnosisDisplayObject}
                          dignosisSubthresholdList={dignosisSubthresholdList}
                          isEdit={assessmentRecommendationEditMode}
                          handleInputChange={handleDiagnosisInputChange}
                          dignosisValueChange={handleSetDignosisReportObject}

                        />
                      )}


                    {diagnosisLoading && <LoadingReport />}
                    {!diagnosisLoading &&
                      dignosisPrincipalList.length === 0 &&
                      dignosisSubthresholdList.length === 0 && (
                        <AssessmentRecommendationSubthreshold />
                      )}
                  </Typography>
                </Box>

                {!diagnosisLoading &&
                  !diagnosisIsExpanded &&
                  diagnosisList.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "auto",
                        p: 1,
                      }}
                    >
                      <Button
                        size="small"
                        startIcon={<VisibilityIcon sx={{ color: "#ffcc00" }} />}
                        onClick={() => handleViewMore("diagosis")}
                        sx={{ textTransform: "none", color: "black" }}
                      >
                        {diagnosisIsExpanded ? "View Less" : "View More"}
                      </Button>
                      <Button
                        size="small"
                        endIcon={<DownloadIcon />}
                        sx={{ textTransform: "none", color: "black" }}
                        onClick={() => downloadTxtFile("aida_dignosis")}
                      >
                        Download
                      </Button>
                    </Box>
                  )}
                {assessmentRecommendationEditMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      p: 1,
                      gap: 1,
                    }}
                  >

                    <LoadingButton
                      size="small"
                      color="primary"
                      variant="contained"
                      sx={commonBtnStyle}
                      disabled={isReportButtonDisabledDueToLoading}
                      loading={isReportButtonDisabledDueToLoading}
                      onClick={() => handleReportUpdate("dignosis")}
                    >
                      Update
                    </LoadingButton>

                  </Box>
                )}
              </Paper>

              {/* Feedback */}
              {diagnosisIsExpanded && (
                <SessionFeedback
                  sessionid={sessionid}
                  reportid={currentExpandedReport}
                  feedbackExpanded={feedbackExpanded}
                />
              )}
            </Grid>
          )}

        {/* Session Transcript */}
        {!sessionSummaryIsExpanded &&
          !diagnosisIsExpanded &&
          !treatmentIsExpanded && (
            <Grid item xs={12} md={sessionTranscriptisExpanded ? 12 : 6}>
              <Paper
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: sessionTranscriptisExpanded ? "300px" : "268px",
                  transition: "all 0.3s ease",
                  border: "1px solid #cfcfcf",
                }}
              >
                <Box sx={{ flex: "1 0 auto", p: 2 }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <Grid container spacing={2} justifyContent="flex-start">
                        <Grid item>
                          <IconButton
                            sx={{
                              borderRadius: "50%",
                              backgroundColor: "#ffcc00",
                              fontSize: "small",
                              cursor: "default",
                              "&:hover": {
                                backgroundColor: "#ffcc00", // Keeps the background color the same on hover
                              },
                            }}
                          >
                            <Chat sx={{ fontSize: "small", color: "black" }} />
                          </IconButton></Grid>
                        <Grid item><Typography sx={{ fontWeight: "bold" }}>
                          Session Transcript
                        </Typography>
                        </Grid>
                        <Grid item>
                          <div>
                            <CachedIcon
                              onClick={fetchSessionTranscript}
                              style={{ cursor: "pointer" }}
                            />
                          </div></Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      {
                        sessionTranscriptEditMode ?
                          <CloseIcon
                            onClick={handleSessionTranscriptCloseMode}
                            style={{ cursor: "pointer" }} /> :
                          <EditIcon
                            onClick={handleSessionTranscriptEditMode}
                            style={{ cursor: "pointer" }} />

                      }
                    </Grid>
                  </Grid>

                  <Box height={10}></Box>

                  {!sessionTranscriptLoading &&
                    !sessionTranscriptList.length && <LoadingReport />}

                  {!sessionTranscriptLoading && (
                    <Typography
                      variant="body2"
                      component="div"
                      id="sessionTranscriptDiv"
                      sx={{
                        flex: 1, // Makes it fill the available space
                        minHeight: "150px",
                        maxHeight: sessionTranscriptisExpanded
                          ? "300px"
                          : "50px", // Corrected to "50px"
                        overflowY: sessionTranscriptisExpanded
                          ? "auto"
                          : "hidden",
                        transition: "max-height 0.3s ease", // Smooth transition when expanding/collapsing
                        overflowX: "hidden",
                      }}
                    >
                      {sessionTranscriptList.length && sessionTranscriptList.map((item, i) => (
                        <div key={i}>
                          <strong style={{ justifyContent: "flex-end" }}>
                            {item.speaker}:
                          </strong>{" "}
                          {sessionTranscriptEditMode ? (
                            <TextField
                              variant="standard"
                              fullWidth
                              multiline
                              value={editedLines[i] || ""}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => handleLineChange(i, e.target.value)}
                            />
                          ) : (
                            item.text
                          )}

                          <br />
                        </div>
                      ))}
                    </Typography>
                  )}

                  {sessionTranscriptLoading && (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ mt: 3 }}
                    >
                      <CircularProgress />
                    </Box>
                  )}
                </Box>

                {!sessionTranscriptLoading &&
                  !sessionTranscriptisExpanded &&
                  sessionTranscriptList.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "auto",
                        p: 1,
                      }}
                    >
                      <Button
                        size="small"
                        startIcon={<VisibilityIcon sx={{ color: "#ffcc00" }} />}
                        onClick={() => handleViewMore("session_transcript")}
                        sx={{ textTransform: "none", color: "black" }}
                      >
                        {sessionTranscriptisExpanded
                          ? "View Less"
                          : "View More"}
                      </Button>
                      <Button
                        size="small"
                        endIcon={<DownloadIcon />}
                        sx={{ textTransform: "none", color: "black" }}
                        onClick={() => downloadTxtFile("session_transcript")}
                      >
                        Download
                      </Button>

                    </Box>
                  )}
                {/* Save / Cancel buttons when editing */}
                {sessionTranscriptEditMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      p: 1,
                      gap: 1,
                    }}
                  >
                    <LoadingButton
                      size="small"
                      color="primary"
                      variant="contained"
                      sx={commonBtnStyle}
                      disabled={isReportButtonDisabledDueToLoading}
                      loading={isReportButtonDisabledDueToLoading}
                      onClick={() => handleReportUpdate("transcript")}
                    >
                      Update
                    </LoadingButton>

                  </Box>
                )}

              </Paper>

              {/* Feedback */}
              {sessionTranscriptisExpanded && (
                <SessionFeedback
                  sessionid={sessionid}
                  reportid={currentExpandedReport}
                  feedbackExpanded={feedbackExpanded}
                />
              )}
            </Grid>
          )}

        {/* AIDA Treatment Plan Recommendation */}
        {!sessionTranscriptisExpanded &&
          !sessionSummaryIsExpanded &&
          !diagnosisIsExpanded && (
            <Grid item xs={12} md={treatmentIsExpanded ? 12 : 6}>
              <Paper
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: treatmentIsExpanded ? "300px" : "268px",
                  transition: "all 0.3s ease",
                  border: "1px solid #cfcfcf",
                }}
              >
                <Box sx={{ flex: "1 0 auto", p: 2 }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <Grid container spacing={2} justifyContent="flex-start">
                        <Grid item>
                          <IconButton
                            sx={{
                              borderRadius: "50%",
                              backgroundColor: "#ffcc00",
                              fontSize: "small",
                              cursor: "default",
                              "&:hover": {
                                backgroundColor: "#ffcc00", // Keeps the background color the same on hover
                              },
                            }}
                          >
                            <Chat sx={{ fontSize: "small", color: "black" }} />
                          </IconButton></Grid>
                        <Grid item><Typography sx={{ fontWeight: "bold" }}>
                          Recommendations for Supportive Actions
                        </Typography>
                        </Grid>
                        <Grid item>
                          <div>
                            <CachedIcon
                              onClick={fetchSessionAIDATreatmentPlan}
                              style={{ cursor: "pointer" }}
                            />
                          </div></Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      {
                        TreatmenteditMode ?
                          <CloseIcon
                            onClick={handleTreatmentCloseMode}
                            style={{ cursor: "pointer" }} /> :
                          <EditIcon
                            onClick={handleTreatmentEditMode}
                            style={{ cursor: "pointer" }} />

                      }
                    </Grid>
                  </Grid>

                  <Box height={10}></Box>
                  <Typography
                    variant="body2"
                    component="div"
                    id="sessionTreatmentPlanDiv"
                    sx={{
                      flex: 1, // Makes it fill the available space
                      minHeight: "150px", // Set minimum height for the transcript
                      maxHeight: treatmentIsExpanded ? "300px" : "50px", // Expand/Collapse max height
                      overflowY: treatmentIsExpanded ? "auto" : "hidden",
                      transition: "max-height 0.3s ease", // Smooth transition when expanding/collapsing
                      overflowX: "hidden",
                    }}
                  >
                    {!diagnosisLoading && diagnosisList.length > 0 && (
                      <>
                        <span style={sessionReportTitle}>
                          Supportive Care Plan Summary
                        </span>
                        <ul>
                          <PatientFormatArray
                            subIndex="pharmacotherapy"
                            keyName="Medications"
                            value={treatmentDetailInfo.pharmacotherapy}
                            isEditing={TreatmenteditMode}
                            inputs={TreatmentTextInputs}
                            onChange={handleTreatmentTextInputChange}
                          />

                          <PatientFormatArray
                            subIndex="psychotherapy"
                            keyName="Therapies"
                            value={treatmentDetailInfo.psychotherapy}
                            isEditing={TreatmenteditMode}
                            inputs={TreatmentTextInputs}
                            onChange={handleTreatmentTextInputChange}
                          />
                        </ul>
                        <span style={sessionReportTitle}>Pharmacological</span>
                        <Box height={10}></Box>
                        <TreatmentPlanPharmacologicalTable
                          data={pharmacologicalMedicationList}
                          TreatmenteditMode={TreatmenteditMode}
                          TreatmentTextInputs={TreatmentTextInputs}
                          handleTreatmentInputChange={
                            handleTreatmentTextInputChange
                          }
                        />

                        <Box height={10}></Box>
                        <span style={sessionReportTitle}>
                          Non-Pharmacological
                        </span>
                        <Box height={10}></Box>
                        <TreatmentPlanNonPharmacologicalTable
                          data={nonPharmacologicalMedicationList}
                          TreatmenteditMode={TreatmenteditMode}
                          TreatmentTextInputs={TreatmentTextInputs}
                          handleTreatmentInputChange={
                            handleTreatmentTextInputChange
                          }
                        />

                      </>
                    )}
                    {!treatmentLoading && !treatmentPlanList.length && (
                      <LoadingReport />
                    )}
                    {treatmentLoading && (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ mt: 3 }}
                      >
                        <CircularProgress />
                      </Box>
                    )}
                  </Typography>
                </Box>

                {!treatmentLoading &&
                  !treatmentIsExpanded &&
                  !sessionTranscriptisExpanded &&
                  treatmentPlanList.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "auto",
                        p: 1,
                      }}
                    >
                      <Button
                        size="small"
                        startIcon={<VisibilityIcon sx={{ color: "#ffcc00" }} />}
                        onClick={() => handleViewMore("treatment_plan")}
                        sx={{ textTransform: "none", color: "black" }}
                      >
                        {treatmentIsExpanded ? "View Less" : "View More"}
                      </Button>
                      <Button
                        size="small"
                        endIcon={<DownloadIcon />}
                        sx={{ textTransform: "none", color: "black" }}
                        onClick={() =>
                          downloadTxtFile("session_treatment_plan")
                        }
                      >
                        Download
                      </Button>
                    </Box>
                  )}
                {TreatmenteditMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      p: 1,
                      gap: 1,
                    }}
                  >

                    <LoadingButton
                      size="small"
                      color="primary"
                      variant="contained"
                      sx={commonBtnStyle}
                      disabled={isReportButtonDisabledDueToLoading}
                      loading={isReportButtonDisabledDueToLoading}
                      onClick={() => handleReportUpdate("treatment")}
                    >
                      Update
                    </LoadingButton>
                  </Box>
                )}
              </Paper>

              {/* Feedback */}
              {treatmentIsExpanded && (
                <SessionFeedback
                  sessionid={sessionid}
                  reportid={currentExpandedReport}
                  feedbackExpanded={feedbackExpanded}
                />
              )}
            </Grid>
          )}
      </Grid>
    </AppDrawer>
  );
};

export default SessionReport;
